var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"app-container"},[_c('account-setting'),_c('cycle-setting'),_c('receivers-setting'),_c('wechatFeePercent-setting'),_c('fee-display-names-setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }